export const getPlans = ({ planReducer: { plans = [] } = {} }) => plans;
export const getPlansFilter = ({ planReducer: { filter = {} } = {} }) => filter;
export const getPlansCount = ({ planReducer: { count = 0 } = {} }) => count;
export const getPartnerOffer = ({
  planReducer: { partner_offers = [] } = {},
}) => partner_offers;
export const getPartnersOfferFilter = ({
  planReducer: { partner_offer_filter = {} } = {},
}) => partner_offer_filter;
